// extracted by mini-css-extract-plugin
module.exports = {"telInput":"vJ7yofNZ","areaCodeSelect":"VTZoPsKx","disabled":"_5daJAPh"};